<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>About Foundation </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
            alt="GHRSCF" />
    </div>
</section>
<section class="section section-sm about-us section-banner-bg-1">
    <div class="container">
        <div class="widget_title inner-title">
            <h4>ABOUT FOUNDATION</h4>
        </div>
        <p class="text-justify">G H Raisoni Sports & Cultural Foundation GHRSCF is established in the
            year 2011 and is incorporated under Section 25 of Companies Act 1956 (No. 1 of 1956)
            (Revised Section 8 of Companies act 2013).</p>
        <p class="text-justify">
            GHRSCF will embrace the benefits of Culture and Sport, recreation and fitness in building a
            healthy community and developing lifelong connections to the Society, Students and will
            support the provision of quality
            facilities and programmes, it has started taking steps towards the sustainable development.
            GHRSCF is an undertaking of Raisoni Education and is aligned to the Vision and Mission of
            Raisoni Education.
        </p>
        <p class="text-justify">
            SPORTS & CULTURE in the broadest understanding of the term means the totality of all
            Physical, Mental, spiritual, material, intellectual and emotional features of a society or
            social group and alongside Sports,
            Games, art and literature includes also the way of life, ways of co-existence, systems of
            values, traditions and views. When assessing the role of sports & culture in the life of
            each state and community, it is
            important not to impose limits upon it, judging about it only as to its as to its
            applicability, but to foster the development of each individual’s creative potential and
            participation in the processes. Sports &
            Culture not only brings social cohesion to society, but also educates, enriching the process
            of life-long education with new informal possibilities for the growth of personality.
        </p>
        <div class="widget_title inner-title">
            <h4>BASIC OBJECTIVES OF G H RAISONI SPORTS & CULTURAL FOUNDATION</h4>
        </div>
        <ul class="list-style list-style1">
            <li>Providing the right forms of support and recognition for Athletes Sports persons and
                individual artists is an important element of this Foundation.</li>
            <li>
                This includes pathways from school and university to work, opportunities for emerging
                sports persons & artists to get a foothold, opportunities for mid-career people to
                consolidate and recognition of the
                lifetime contribution of eminent in all fields.
            </li>
            <li>
                All our activities aim to increase Sports, Arts and culture professionals’ interaction
                between RGI and the target population. (This is grass-roots work almost at the level of
                individuals, and its effects may
                not be visible for years but will provide the great foundation for the future to come.)
            </li>
            <li>
                All the institute’s projects aim to increase the professional competence. It depends on
                the project whether this increasing competence relates to content (e.g. artistic work)
                or career development (networks,
                country-specific sector knowledge).
            </li>
            <li>To provide learning experience to all.</li>
            <li>To put new emphasis and to define the directions of strategic development within the
                development of Indian Sports and Culture policy.</li>
        </ul>
    </div>
</section>
